import React from 'react';
import {ErrorView} from '../error/ErrorView';
import {CopyText} from '../../components';
import {Button} from '@mui/material';
import {useTranslate} from '../../hooks';
import {useNavigate} from 'react-router-dom';

export type AuthErrorType =
  | 'param_code_undefined'
  | 'param_state_undefined'
  | 'auth_state_invalid';
export const AuthenticationErrorPage: React.FC<{
  error: AuthErrorType | unknown;
  description?: string | null;
}> = ({error, description}) => {
  const navigate = useNavigate();
  const translate = useTranslate();

  if (error === 'auth_state_invalid') {
    return (
      <ErrorView
        title={translate('auth.redirect.error.title')}
        subtitle={translate('auth.redirect.error.subtitle')}>
        <CopyText
          value={window.location.origin + window.location.pathname}
          copy={window.location.href}
        />
      </ErrorView>
    );
  }

  return (
    <ErrorView
      title={translate('common.error')}
      subtitle={description || String(error)}>
      <Button onClick={() => navigate('/demo')}>
        {translate('common.retry')}
      </Button>
    </ErrorView>
  );
};
